<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> {{ bCharts ? 'نمودار کیفی رانندگان' : 'وضعیت سفرها' }} </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="searchModel">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>
    
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
    
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
    
                <input type="text" formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />
    
            </ng-persian-datepicker>
    
        </div>

        <!-- حوزه خدمت -->

        <div class="col-12 col-md-auto position-relative">
    
            <label class="mb-2"> حوزه خدمت </label>

            <select  class="form-select" formControlName="iMobileDomain">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Domain" [value]="item.iMobileDomain">
                    
                    {{item.strComment}} 
                
                </option>

            </select>

        </div>

        <!-- بررسی -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="searchTrip()"> &nbsp; بررسی &nbsp; </button>

        </div>

        <!-- خروجی اکسل -->

        <div *ngIf="!bCharts" class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportexcel('Export_Excel')"> خروجی اکسل </button>

        </div>

    </form>

    <!-- جدول نتایج -->

    <div class="border border-2 mt-3 p-2">

        <!-- نمودار کیفی رانندگان -->

        <ng-container *ngIf="bCharts;else tripStatus">

            <div class="section mt-2" style="height:calc(100vh - 180px);overflow: auto;">

                <div class="col-12 row justify-content-around rounded mb-2 border-bottom">
    
                    <p class="text-center f18 py-2"> تعداد سفر به تفکیک راننده  </p>
            
                    <canvas id="myChart1" style="max-height: 350px !important;"></canvas>
            
                </div>

                <div class="col-12 row justify-content-around rounded border-bottom">
    
                    <p class="text-center f18 py-2"> شاخص کیفی راننده </p>
            
                    <canvas id="myChart2" style="max-height: 350px !important;"></canvas>
            
                </div>

            </div>

        </ng-container>

        <!-- وضعیت سفرها -->

        <ng-template #tripStatus>

            <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm (keyup)="filter_list($event.target)">

            <div class="section border border-2 mt-2" style="height:calc(100vh - 260px);overflow: auto;">
    
                <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        
                    <thead>
                
                        <tr class="">
            
                            <th class="text-center col-1"> # </th>
        
                            <th class="text-center"> حوزه خدمت </th>
    
                            <th class="text-center"> تعداد کل  </th>
    
                            <th class="text-center"> ثبت شده  </th>
    
                            <th class="text-center"> تایید شده  </th>
    
                            <th class="text-center"> اختصاص راننده  </th>
    
                            <th class="text-center"> در حال انجام  </th>
    
                            <th class="text-center"> انجام‌شده  </th>
    
                            <th class="text-center"> لغو شده  </th>
    
                            <th class="text-center"> ماموریتی  </th>
            
                        </tr>
                        
                    </thead>
    
                    <tbody>
    
                        <tr class="col-12 text-center" *ngFor="let item of list_Trips;let i = index">
    
                            <th> {{ i + 1 | faNum }} </th>
    
                            <td class=""> {{ item.strMobileDomain_strComment }} </td>
    
                            <td class=""> {{ item.iTotal | faNum }} </td>
    
                            <td class=""> {{ item.iRegistered | faNum  }} </td>
                            
                            <td class=""> {{ item.iConfirmed | faNum  }} </td>
    
                            <td class=""> {{ item.iDriverAssignment | faNum  }} </td>
    
                            <td class=""> {{ item.iInProgress | faNum }} </td>
    
                            <td class=""> {{ item.iDdone | faNum }} </td>
    
                            <td class=""> {{ item.iCanceled | faNum }} </td>
    
                            <td class=""> {{ item.iMission | faNum }} </td>
    
                        </tr>
    
                    </tbody>
        
                </table>
        
            </div>
    
            <div class="row gx-2 gy-2 gy-md-0 py-2 px-1 rounded" style="background-color: #5eead4;margin: 6px 0px 0px!important;">
    
                <div class="col-12 col-md-auto px-1">
    
                    تعداد کل  : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iTotal | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای تایید شده : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iRegistered | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای اختصاص داده شده به راننده : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iDriverAssignment | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای در حال انجام	 : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iInProgress | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای انجام‌شده : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iDdone | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای لغو شده : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iCanceled | faNum }} 
                    
                    </span>
    
                    <span> / </span>
    
                </div>
    
                <div class="col-12 col-md-auto px-1">
    
                    سفرهای ماموریتی : 
    
                    <span style="color: navy;text-decoration: underline;font-size: 18px;"> 
                        
                        {{ this.trip_Obj?.iMission | faNum }} 
                    
                    </span>
    
                </div>
    
            </div>

        </ng-template>

    </div>

</main>